// react and js
import { React } from "react";

// mui

// components

// hooks

// layouts

// pages
import Subscriptions from "../pages/subscriptions/Subscriptions";
import Downloads from "../pages/downloads/Downloads";
import Accounting from "../pages/accounting/Accounting";
import DistributorPortal from "../pages/distributor_portal/DistributorPortal";
import EvaluationPortal from "../pages/evaluation_portal/EvaluationPortal";
import ApplicationSettings from "../pages/application_settings/ApplicationSettings";

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
const features = [
  {
    title: "Subscriptions",
    path: "/subscriptions",
    icon: "eva:layers-outline",
    backendLinking: "obfs348d78fb69464a00", // Clear: dashboard_feature_subscriptions
    trueObfs: "obfs2f1c786d5ef25c55",
    route: { path: "subscriptions", element: <Subscriptions /> },
  },
  {
    title: "Tick data download",
    path: "/downloads",
    icon: "eva:download-outline",
    backendLinking: "obfs998de9826cbc26b1", // Clear: dashboard_feature_downloads
    trueObfs: "obfs7c64df1a627d2987",
    route: { path: "downloads", element: <Downloads /> },
  },
  {
    title: "Billing",
    path: "/accounting",
    icon: "eva:email-outline",
    backendLinking: "obfsaa8911d51f968403", // Clear: dashboard_feature_accounting
    trueObfs: "obfs5828c1b7bf8ebf20",
    route: { path: "accounting", element: <Accounting /> },
  },
  {
    title: "Distributor portal",
    path: "/distributor-portal",
    icon: "eva:briefcase-fill",
    backendLinking: "obfs103d6174421f3079", // Clear: dashboard_feature_distributor_portal
    trueObfs: "obfsdf2b6301086ec5eb",
    route: { path: "distributor-portal", element: <DistributorPortal /> },
  },
  {
    title: "Evaluation portal",
    path: "/evaluation-portal",
    icon: "eva:people-fill",
    backendLinking: "obfs6ba90c02fea078eb", // Clear: dashboard_feature_evaluation_portal
    trueObfs: "obfs415152af3dd89e65",
    route: { path: "evaluation-portal", element: <EvaluationPortal /> },
  },
  {
    title: "Application settings",
    path: "application-settings",
    icon: "eva:options-2-fill",
    backendLinking: "obfs0921d9fe7b9543ab", // Clear: dashboard_feature_application_settings
    trueObfs: "obfsc555894615b268f9",
    route: { path: "application-settings", element: <ApplicationSettings /> },
  },
];

export default features;
